import ApiClient from './ApiClient';

class CampaignsFlowAPI extends ApiClient {
  constructor() {
    super('campaigns_flows', { accountScoped: true });
  }

  async getAll(){
    return await axios.get(this.url);
  }
  async getById(id){
    return await axios.get(`${this.url}/${id}`);
  }

  async update(payload){
    const { id } = payload;
    return await axios.put(`${this.url}/${id}`, payload);
  }
  async delete(id){
    return await axios.delete(`${this.url}/${id}`);
  }

  async create(payload){
    return await axios.post(this.url, payload);
  }

  executionSummary(id, params = {}) {
    return axios.get(`${this.url}/${id}/execution_summary`, { params });
  }

  executions(id, params = {}) {
    return axios.get(`${this.url}/${id}/executions`, { params });
  }

  exportExecutions(id, params = {}) {
    return axios.get(`${this.url}/${id}/executions/export`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new CampaignsFlowAPI();
